import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Hardware/Equipment Module Service Stores
 * Updated to match backend api-types
 *
 * Note: Hardware services don't have a dedicated api-types folder.
 * Related services may be found in the equipment api-types folder.
 */
export const hardwareStores: ServiceStoreConfig[] = [
  // No hardware-specific api-types exist yet
  // Equipment-related services are in a separate equipment module
];
